import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommentsService } from '../../service/comments.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ContentType } from 'na-lib';
import { ContentTypeService } from '../../service/content-type.service';
import { SettingsService } from '../../service/settings.service';
import { ActivatedRoute } from '@angular/router';
import { ContentTypesSchemaViewDialogComponent } from '../content-types-schema-view-dialog/content-types-schema-view-dialog.component';
import { deepCopy } from 'na-lib';
import { ContentTypeDisplayTemplateDialogComponent } from '../content-type-display-template-dialog/content-type-display-template-dialog.component';
import { deleteField } from '@angular/fire/firestore';

@Component({
    selector: 'content-type-settings-dialog.component',
    templateUrl: './content-type-settings-dialog.component.html',
    styleUrls: ['./content-type-settings-dialog.component.css'],
    standalone: false
})
export class ContentTypeSettingsDialogComponent {
  oldContentTypeData:ContentType
  routerUrl:any
  idToShow:any
  currentRoute:any
  allContents:any
  contentData:ContentType
  editMode:any
  contentForm!:FormGroup
  id:any
  subtitleKeys:string[]=[]
  activeSubtitleIndex = 0;
  activeKeyTarget: 'title' | 'subtitle' = 'subtitle';
  idUndefined=false
  oldData:any
  deleteMode=false
  contenttype:any
  displayName:any
  titleKey:any
  contentTypeUserRights_update:any
  contentTypeUserRights_delete:any
  nfcURLPrefix:any
  routerExtras:any
  routerParams=false
  schemaDefinition:any

  constructor(public dialogRef: MatDialogRef<ContentTypeSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private router: ActivatedRoute,
    private commentsService: CommentsService,
    private fb: FormBuilder,
    private translate:TranslateService,
    private contentTypeService: ContentTypeService,
    private commentService: CommentsService,
    private settingsService: SettingsService
    ){
      dialogRef.disableClose = true;
  }

  ngOnInit(){
    this.idToShow = this.data['contentTypeId']
    this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
    this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
      this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']
    })
    if(!this.contentTypeUserRights_update)
    document.getElementById("btn-edit").style.backgroundColor='#e0e0e0'

    this.contentForm = this.fb.group({
      contextId:[],
      id:[],
      passTemplateId:[],
      passId:[],
      displayName:[],
      displaySections:[],
      schema:[],
      metaTemplate: [],
      schemaMode:[],
      titleKey: [],
      subtitleKeys:[],
      nfcURLPrefix: [],
      advancedExperienceId:[]
    })

    this.getContentTypeId()
  }

  async getContentTypeId(){
    try{
      this.commentService.progressSpin.emit(true)
      if(!this.data['contentType'])
        this.contenttype = await this.settingsService.observeContextsContentTypesIdFirestore(this.idToShow)
      else{
        this.contenttype = deepCopy(this.data['contentType'])
        if(this.contenttype.creationDate)
          this.contenttype.creationDate = new Date(this.contenttype.creationDate)
          
        if(this.contenttype.timeStamp)
          this.contenttype.timeStamp = new Date(this.contenttype.timeStamp)
      }
      this.contentData= new ContentType 
      this.contentData.setFromAny(this.contenttype)
        if(this.contenttype.displayName)
        this.displayName = this.contenttype.displayName

        if(this.contenttype.titleKey)
        this.titleKey = this.contenttype.titleKey
        
        this.oldData = deepCopy(this.contentData)

      if(!this.contentData['id']){
        this.contentData['id']= this.idToShow
      }
  
      this.oldContentTypeData = new ContentType()
      this.oldContentTypeData.setFromAny(this.contentData)

      this.initializeFormWithdata()
      this.commentService.progressSpin.emit(false)

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)
    }
  }

  initializeFormWithdata() {
    const { contextId, id, passTemplateId, displayName, titleKey, subtitleKeys, nfcURLPrefix, schema, schemaMode, advancedExperienceId, displaySections, metaTemplate} = this.contenttype
    this.contentForm.patchValue({
      contextId: contextId ? contextId : undefined,
      id: id ? id : this.idToShow,
      passTemplateId:  passTemplateId ? passTemplateId : undefined,
      displayName : displayName ? displayName : undefined,
      titleKey : titleKey ? titleKey : undefined,
      nfcURLPrefix: nfcURLPrefix ? nfcURLPrefix : undefined,
      schema: schema ? schema : undefined,
      metaTemplate: metaTemplate ? metaTemplate : undefined,
      schemaMode: schemaMode ? schemaMode : undefined,
      advancedExperienceId : advancedExperienceId ? advancedExperienceId : undefined,
      displaySections: displaySections ? displaySections : undefined
    })
    
    // Init  subtitleKeys
    if (subtitleKeys) {
      this.subtitleKeys = subtitleKeys;
    } else {
      this.subtitleKeys = [];
    }

    // Dynamically add controls
    this.subtitleKeys.forEach((key, index) => {
      this.contentForm.addControl('subtitleKey' + index, this.fb.control(key));
    });

    if(this.schemaDefinition){
      this.editMode=true
      this.contentForm.patchValue({schema: this.schemaDefinition})
    }
    
  }

  openDisplayTemplateView(){
    let dialogRef= this.dialog.open(ContentTypeDisplayTemplateDialogComponent, {
      width: '920px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      data: {
        contentType:this.contentForm.value,
        id: this.idToShow
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        this.contentForm.patchValue({displaySections: result[1]})
      }
    });
  }

  openSchemaView(){
    let dialogRef= this.dialog.open(ContentTypesSchemaViewDialogComponent, {
      width: '100vw',
      maxWidth: '100vw',
      height: '100dvh',
      maxHeight: '100dvh',
      panelClass: 'schema-fullscreen-dialog',
      data: {
        contentType:this.contentForm.value,
        id: this.idToShow
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        if(result[1].properties && result[1].properties.length!=0 )
          this.contentForm.patchValue({schema: result[1]})
        else
          this.contentForm.patchValue({schema: {}})
        this.contentForm.patchValue({metaTemplate: result[2]})
      }
    });
  }

  addSubtitleKey(){
  
    this.subtitleKeys.push(this.translate.instant("pass.subtitle"));
    const newIndex = this.subtitleKeys.length - 1;
    this.contentForm.addControl('subtitleKey' + newIndex, this.fb.control(this.translate.instant("pass.subtitle")));
    this.activeSubtitleIndex = newIndex;
  
    this.contentForm.patchValue({
      subtitleKeys: this.subtitleKeys
    });
 
  }

  get availableSubtitleKeys(): string[] {
    return this.extractSchemaKeys(this.contentForm?.value?.schema || this.contenttype?.schema);
  }

  setActiveSubtitle(index: number): void {
    this.activeSubtitleIndex = index;
    this.activeKeyTarget = 'subtitle';
  }

  insertSubtitleKey(key: string): void {
    if (this.activeKeyTarget === 'title') {
      this.contentForm.get('titleKey')?.setValue(key);
      this.contentForm.get('titleKey')?.markAsDirty();
      return;
    }
    if (!this.subtitleKeys.length) this.addSubtitleKey();
    const index = Math.min(this.activeSubtitleIndex, this.subtitleKeys.length - 1);
    const control = this.getSubtitleControl(index);
    control.setValue(key);
    control.markAsDirty();
    this.subtitleKeys[index] = key;
    this.contentForm.patchValue({ subtitleKeys: this.subtitleKeys });
  }

  setActiveTitleKey(): void {
    this.activeKeyTarget = 'title';
  }

  getSubtitleControl(index: number): FormControl {
    return this.contentForm.get('subtitleKey' + index) as FormControl;
  }
  deleteSubtitleKey(index: number) {
    this.subtitleKeys.splice(index, 1);
    this.contentForm.removeControl('subtitleKey' + index);
  
    // Update the remaining controls
    this.subtitleKeys.forEach((_, i) => {
      if (i >= index) {
        const oldName = 'subtitleKey' + (i + 1);
        const newName = 'subtitleKey' + i;
  
        // Rename
        const control = this.contentForm.get(oldName);
        if (control) {
          this.contentForm.removeControl(oldName);
          this.contentForm.addControl(newName, control);
        }
      }
    });
  
    this.contentForm.patchValue({
      subtitleKeys: this.subtitleKeys
    });
    this.activeSubtitleIndex = Math.max(0, Math.min(this.activeSubtitleIndex, this.subtitleKeys.length - 1));
  }

  cancelEditContentType(){
    const message = this.translate.instant("SnackBarConstants.UPDATE_DISMISS")
    this.commentService.addSnackBar.emit(message) //showSnackbar
    this.dialogRef.close([false, this.oldContentTypeData])
  }

  async saveEditContentType() {
    this.commentService.progressSpin.emit(true);
  
    try {
      const value = this.contentForm.value;
      const contentType = new ContentType();

      const { id, contextId, passTemplateId, displayName, titleKey, schema, schemaMode, displaySections, metaTemplate } = value;
  
      const subtitleKeys = this.subtitleKeys.map((_, index) => this.contentForm.get('subtitleKey' + index)?.value);
  
      const newContentType = {
        id,
        contextId,
        passTemplateId,
        displayName,
        titleKey,
        subtitleKeys: subtitleKeys ? (subtitleKeys?.length!=0 ? subtitleKeys : deleteField() ) : undefined,
        schema: schema ? (Object.keys(schema)?.length!=0 ? schema : deleteField() ) : undefined,
        metaTemplate: metaTemplate?.fields?.length ? metaTemplate : deleteField(),
        schemaMode,
        displaySections: displaySections ? ( displaySections?.length!=0 ? displaySections : deleteField() ) : undefined
      };
  
      contentType.setFromAny(newContentType);
      (contentType as ContentType & { metaTemplate?: unknown }).metaTemplate = newContentType.metaTemplate;

      await this.contentTypeService.updateContentType(contentType, this.oldContentTypeData);

      this.commentService.progressSpin.emit(false);
      const message = this.translate.instant("SnackBarConstants.UPDATE_OK");
      this.commentService.addSnackBar.emit(message);
      // this.resetList();
      this.dialogRef.close([true, contentType]);
  
    } catch (error) {
      console.log(error)
      this.commentService.progressSpin.emit(false);
      const message = this.translate.instant("SnackBarConstants.UPDATE_FAILED");
      this.commentService.addSnackBar.emit(message);
    }
  }

  private extractSchemaKeys(schema: any): string[] {
    const nodes = Array.isArray(schema?.properties) ? schema.properties : Array.isArray(schema) ? schema : [];
    const keys = new Set<string>();
    const visit = (items: any[], prefix = '') => {
      items.forEach(item => {
        const key = String(item?.key || '').trim();
        const path = key ? (key.includes('.') || !prefix ? key : `${prefix}.${key}`) : prefix;
        const childProperties = Array.isArray(item?.properties) ? item.properties : [];
        const itemProperties = Array.isArray(item?.items?.properties) ? item.items.properties : [];
        if (childProperties.length) {
          visit(childProperties, path);
          return;
        }
        if (itemProperties.length) {
          visit(itemProperties, path);
          return;
        }
        if (path) keys.add(path);
      });
    };
    visit(nodes);
    return Array.from(keys).sort((left, right) => left.localeCompare(right));
  }

}
